import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Navigation } from 'swiper/modules';
import { useInView } from 'react-intersection-observer';
import 'swiper/swiper-bundle.css';
import './Consultorio.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const LazyBackgroundImageSlide = ({ image }) => {
    const { ref, inView } = useInView({ triggerOnce: true });

    return (
        <div
            ref={ref}
            className='slide-clinic'
            style={{
                backgroundImage: inView ? `url(${image})` : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                borderRadius: '0.75rem',
                transition: 'background-image 0.3s ease-in-out',
            }}
        />
    );
};

const Consultorio = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
            delay: 100,
        });
    }, []);

    const images = [
        '/images/clinica/clinica-10.webp',
        '/images/clinica/clinica-09.webp',
        '/images/clinica/clinica-08.webp',
        '/images/clinica/clinica-05.webp',
        '/images/clinica/clinica-03.webp',
    ];

    return (
        <div className='consultorio-main'>
            <div className='carousel-slider-container-clinic'>
                <div className='carousel-header-clinic'>
                    <h2 className='carousel-title-clinic'>Nosso consultório</h2>
                </div>
                <Swiper
                    modules={[EffectCoverflow, Pagination, Navigation]}
                    effect='coverflow'
                    grabCursor={true}
                    centeredSlides={true}
                    slidesPerView={2}
                    loop={true}
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 200,
                        modifier: 2,
                        slideShadows: true,
                    }}
                    pagination={{ clickable: true }}
                    navigation
                >
                    {images.map((image, index) => (
                        <SwiperSlide key={index}>
                            <LazyBackgroundImageSlide image={image} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className='clinic-container'>
                <div className='main-slogan' data-aos="fade-right" data-aos-duration="600">
                    <h3 className='clinic-slogan'>
                        <span className='slogan-1'>
                            Nosso consultório é um espaço pensado para você, unindo conforto, acolhimento e personalização.
                        </span>
                        <span className='slogan-2'>
                            Cada detalhe reflete nosso compromisso com sua confiança, bem-estar e segurança.
                        </span>
                    </h3>
                </div>

                <div className='main-morals' data-aos="fade-up" data-aos-duration="600">
                    <div className='morals'>
                        <h6 className='morals-title'>Filosofia:</h6>
                        <span className='morals-span'>
                            Acreditamos que a cirurgia plástica vai além da estética. Ela envolve a transformação da autoestima e a melhoria da qualidade de vida. Meu compromisso é alinhar os desejos e objetivos de cada paciente.
                        </span>
                    </div>
                    <div className='morals'>
                        <h6 className='morals-title'>Atendimento Personalizado:</h6>
                        <span className='morals-span'>
                            Minha equipe e eu entendemos a importância de ouvir e adaptar o plano de tratamento de acordo com cada paciente. Nós nos qualificamos para estar ao seu lado em cada etapa, fornecendo apoio, orientação e cuidados.
                        </span>
                    </div>
                    <div className='morals'>
                        <h6 className='morals-title'>Confiança e Resultados:</h6>
                        <span className='morals-span'>
                            Valorizamos a confiança que nossos pacientes depositam em nós. Nossos resultados falam por si, refletindo a dedicação à satisfação e ao bem-estar de cada indivíduo que atendemos.
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Consultorio;